<!-- each template gets the validator's error value as `let-error` -->
<ng-template vxFormFieldErrorDefault="required">
  {{ 'components.form.errors.required' | transloco }}
</ng-template>
<ng-template vxFormFieldErrorDefault="email">
  {{ 'components.form.errors.email' | transloco }}
</ng-template>
<ng-template vxFormFieldErrorDefault="url">
  {{ 'components.form.errors.url' | transloco }}
</ng-template>
<ng-template vxFormFieldErrorDefault="domain">
  {{ 'components.form.errors.domain' | transloco }}
</ng-template>
<ng-template vxFormFieldErrorDefault="ipv4">
  {{ 'components.form.errors.ipv4' | transloco }}
</ng-template>
<ng-template vxFormFieldErrorDefault="ipv6">
  {{ 'components.form.errors.ipv6' | transloco }}
</ng-template>
<ng-template vxFormFieldErrorDefault="integer">
  {{ 'components.form.errors.integer' | transloco }}
</ng-template>
<ng-template vxFormFieldErrorDefault="minlength" let-error>
  {{
    'components.form.errors.minlength'
      | transloco: { min: error.requiredLength }
  }}
</ng-template>
<ng-template vxFormFieldErrorDefault="maxlength" let-error>
  {{
    'components.form.errors.maxlength'
      | transloco: { max: error.requiredLength }
  }}
</ng-template>
<ng-template vxFormFieldErrorDefault="min" let-error>
  {{ 'components.form.errors.min' | transloco: { min: error.min } }}
</ng-template>
<ng-template vxFormFieldErrorDefault="max" let-error>
  {{ 'components.form.errors.max' | transloco: { max: error.max } }}
</ng-template>
<ng-template vxFormFieldErrorDefault="pattern">
  {{ 'components.form.errors.pattern' | transloco }}
</ng-template>
